// Zone3.js
import React from 'react';
import emiImg from '../ZonetablePoster/EMI.png'; 
import '../ZonetablePoster/allzones.css';

const videoLinks = [
  { title: "The PRUTL TIME-STORM (English)", link: "https://youtu.be/exabZuec_kQ" },
  { title: "The PRUTL TIME-STORM (Hindi)", link: "https://youtu.be/Cdje5v1Tmlk" },
  { title: "When Hearts Whisper Again (English)", link: "https://youtu.be/nE_YYQygunk" },
  { title: "When Hearts Whisper Again (Hindi)", link: "https://youtu.be/iHGU3qTNCyA" },
  { title: "EMI-e-motion (Hindi)", link: "https://youtu.be/vNitPYU3ZV4" },
  { title: "EMI-e-motion (English)", link: "https://youtu.be/c_iYNQjUDU0" },
  { title: "The Last Bus to Kailash (Hindi)", link: "https://youtu.be/aO7A9yyHR7Y" },
  { title: "The Last Bus to Kailash (English)", link: "https://youtu.be/LQnRN7Jt0n4" },
  { title: "THE MIRROR OF ERIS (Hindi)", link: "https://youtu.be/8PH9YJfsO7A" },
  { title: "THE MIRROR OF ERIS (English)", link: "https://youtu.be/Yl_j66MHdtA" }
];

const tableData = [
  {
    picture: emiImg,
    title: "EMI-e-motion The Great Indian Reset",
    genre: "Comedy • Drama • Family • Self-Realization"
  }
];

function Zone3() {
  return (
    <div style={{ backgroundColor: 'black', minHeight: '100vh', padding: '20px' }}>
      <h1 className="zone-title">Zone 3</h1>

      <table className="zone-table">
        <thead>
          <tr>
            <th>Museo Series</th>
            <th>Title</th>
            <th>Genre</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, idx) => (
            <tr key={idx}>
              <td><img src={item.picture} alt={item.title} /></td>
              <td className="title">{item.title}</td>
              <td className="genre">{item.genre}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Videos Grid */}
      <div className="episodes-grid" style={{ marginTop: '40px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {videoLinks.map((video, index) => (
          <div key={index} className="episode-card" style={{ backgroundColor: '#111', padding: '10px', borderRadius: '8px' }}>
            <div className="episode-thumbnail" style={{ height: '180px' }}>
              <iframe
                width="100%"
                height="100%"
                src={video.link.replace("youtu.be/", "www.youtube.com/embed/")}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ borderRadius: '6px' }}
              ></iframe>
            </div>
            <div className="episode-title" style={{ marginTop: '8px', color: 'white', textAlign: 'center' }}>
              {video.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


export default Zone3;
